import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Design = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M8 3C5.79 3 4 4.79 4 7V14C4 15.1 4.9 16 6 16H9V20C9 21.1 9.9 22 11 22H13C14.1 22 15 21.1 15 20V16H18C19.1 16 20 15.1 20 14V3H8ZM8 5H12V7H14V5H15V9H17V5H18V10H6V7C6 5.9 6.9 5 8 5ZM6 14V12H18V14H6Z" />
  </SvgIcon>
));

Design.displayName = 'Design';

export default Design;
